import NoPeIntegrations from './NoPeIntegrations';

export default NoPeIntegrations;
